import React, { useContext } from 'react';

// Components
import EventSessionsList from '../../../_organisms/EventSessionsList';
import MyEventAgenda from '../../../_organisms/MyEventAgenda';
// import MyEventAvailability from '../MyEventAvailability';
import Tabs from '@molecules/Tabs';
import { H4 } from '@styled';

// Helpers
import { EventDetailProvider } from './EventDetailProvider';

const MyEventSchedule = () => {
    const { event, defaultView } = useContext(EventDetailProvider);

    return (
        <div>
            <H4 className="mb-1.25rem">Build Out Your Agenda</H4>

            <Tabs
                defaultActiveTab={defaultView}
                onTabChange={tabKey => {
                    window.history.replaceState(null, '', `/my-icsc/events/${event.event_code}/${tabKey}`);
                }}
            >
                <div tabKey="sessions" title="Sessions List">
                    <EventSessionsList />
                </div>

                <div tabKey="agenda" title="My Agenda">
                    <MyEventAgenda />
                </div>

                {/*
                <div tabKey="availability" title="My Availability">
                    {inView && <MyEventAvailability />}
                </div>
                */}
            </Tabs>
        </div>
    );
};

export default MyEventSchedule;
